import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { AppStateRoot, PostAffirmRequestPayload } from './app.model';
import { getAgencyList, postAffirm, getKeepAlive } from './app.actions';
import { appStateQuery } from './app.selectors';

@Injectable({
  providedIn: 'root',
})
export class AppFacade {
  constructor(private _store$: Store<AppStateRoot>) {}

  loading$ = this._store$.pipe(select(appStateQuery.getDetailsLoaded));
  detailsError$ = this._store$.pipe(select(appStateQuery.getDetailsError));
  agencyListError$ = this._store$.pipe(
    select(appStateQuery.getAgencyListError),
  );

  agencyList$ = this._store$.pipe(select(appStateQuery.getAgencyList));

  agencyResponse$ = this._store$.pipe(select(appStateQuery.getAgencyResponse));

  getIsPostAffirmFailed$ = this._store$.pipe(
    select(appStateQuery.getIsPostAffirmFailed),
  );
  getIsGetAgencyListFailed$ = this._store$.pipe(
    select(appStateQuery.getIsGetAgencyListFailed),
  );
  getAffirmResponse$ = this._store$.pipe(
    select(appStateQuery.getAffirmResponse),
  );

  getAgencyList(): void {
    this._store$.dispatch(getAgencyList());
  }
  postAffirm(request: PostAffirmRequestPayload): void {
    this._store$.dispatch(postAffirm({ request }));
  }

  dispatchKeepAlive(): void {
    this._store$.dispatch(getKeepAlive());
  }
}
